/* eslint-disable @next/next/no-img-element */
import React from 'react';

import { TImage } from 'types/portfolio';

import s from '../PlayfulPortfolio.module.css';

type TClassicPortfolioImageProps = {
  caption: string;
  image: TImage;
};

export const PlayfulPortfolioImage: React.FC<TClassicPortfolioImageProps> = ({
  image: { medium, original },
  caption,
}) => (
  <figure className={s.item}>
    <div className={s.wrapper}>
      <div className={s.imageWrapper}>
        <picture>
          <source srcSet={original} media="(min-width: 1000px)" />
          <img
            alt={caption}
            className={s.image}
            width="500"
            height="500"
            loading="lazy"
            src={medium}
          />
        </picture>
      </div>
      <figcaption className={s.description}>{caption}</figcaption>
    </div>
  </figure>
);
